import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function useStripeAccount(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.stripeAccount(clubId ?? ""),
		queryFn: () => financeApi.stripe.getAccount(clubId!),
		enabled: !!clubId,
		retry: false,
	});
}

export function useConnectStripe(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: { return_url: string; refresh_url: string }) =>
			financeApi.stripe.connect(clubId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.stripeAccount(clubId),
			}),
	});
}

export function useDisconnectStripe(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: () => financeApi.stripe.disconnect(clubId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.stripeAccount(clubId),
			}),
	});
}

export function useStripeDashboardLink(clubId: string) {
	return useMutation({
		mutationFn: () => financeApi.stripe.dashboardLink(clubId),
	});
}

export function useCreateCheckoutSession(clubId: string) {
	return useMutation({
		mutationFn: ({
			invoiceId,
			data,
		}: {
			invoiceId: string;
			data: { success_url: string; cancel_url: string };
		}) => financeApi.stripe.createCheckoutSession(clubId, invoiceId, data),
	});
}
